import clsx from 'clsx';
import React, { useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { useIncrementalHideComponent } from './use-incremental-hide-component';

interface TopStickySectionProps {
  children: React.ReactNode;
  className?: string;
  align: 'top' | 'bottom';
}

const StickySection = ({ children, className, align }: TopStickySectionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const height = ref.current?.clientHeight ?? 0;
  const translate = useIncrementalHideComponent(height);

  return (
    <div ref={ref} style={{ [align]: translate - height }} className={twMerge(clsx('fixed right-0 left-0', className))}>
      {children}
    </div>
  );
};

export default StickySection;
